import React, { useState } from "react";

const ProfileSections = ({ profiledata, isAdvisorUser }) => {
  const [showEducation, setShowEducation] = useState(true);
  const [showExperience, setShowExperience] = useState(true);

  const education = profiledata?.education || [];
  const experience = profiledata?.experience || [];

  return (
    <div className="profile-sections">
      {/* ================= EDUCATION ================= */}
      {/* {education.length > 0 && ( */}
      <div className="ps-card">
        <div
          className="ps-header"
          onClick={() => setShowEducation(!showEducation)}
        >
          <h5>Education</h5>
          <img
            className={`edu-arrow ${showEducation ? "rotate" : ""}`}
            src="/assets/img/eduArrow.svg"
            alt=""
          />
        </div>

        {showEducation && (
          <div className="ps-body">
            {education?.length > 0 ? (
              education.map((item, index) => (
                <div className="ps-content" key={index}>
                  {item?.credential && <h6>{item.credential}</h6>}
                  {item?.school && <p className="company">{item.school}</p>}
                  {item?.dates && <span>{item.dates}</span>}
                </div>
              ))
            ) : (
              <div className="campaignNotFound">
                {isAdvisorUser ? (
                  <img src="/assets/img/eduround.svg" alt="" />
                ) : (
                  <img src="/assets/img/educationCompany.svg" alt="" />
                )}
                <h6 className="m-0">No education added yet</h6>
                <p className="m-0">
                  Education details will appear here once available.
                </p>
              </div>
            )}
          </div>
        )}
      </div>
      {/* )} */}

      {/* ================= EXPERIENCE ================= */}
      {/* {experience.length > 0 && ( */}
      <div className="ps-card">
        <div
          className="ps-header"
          onClick={() => setShowExperience(!showExperience)}
        >
          <h5>Experience</h5>
          <img
            className={`edu-arrow ${showExperience ? "rotate" : ""}`}
            src="/assets/img/eduArrow.svg"
            alt=""
          />
        </div>

        {showExperience && (
          <div className="ps-body">
            {experience?.length > 0 ? (
              experience.map((exp, i) => (
                <div className="ps-exp-item" key={i}>
                  {/* Logo fallback */}
                  <div className="ps-logo">
                    {exp?.company?.charAt(0) || "?"}
                  </div>

                  <div className="ps-content">
                    {/* Main title */}
                    {exp?.title && <h6>{exp.title}</h6>}

                    {/* Company */}
                    {exp?.company && <p className="company">{exp.company}</p>}

                    {/* Duration */}
                    {exp?.duration && <span>{exp.duration}</span>}

                    {/* Roles (nested) */}
                    {exp?.roles?.length > 0 &&
                      exp.roles.map((role, j) => (
                        <div className="ps-sub-role" key={j}>
                          <div className="ps-dotLineSection">
                            <div className="ps-dot"></div>
                            <div className="ps-line"></div>
                            <div className="ps-dot"></div>
                          </div>
                          <div className="contentPS-sub">
                            {role?.title && <h6>{role.title}</h6>}
                            {role?.duration && <span>{role.duration}</span>}

                            <div className="locationDotSec">
                              <div className="locationDot"></div>
                              {role?.location && <p>{role.location}</p>}
                            </div>

                            <div className="locationDotSec">
                              <div className="locationDot"></div>
                              {role?.employmentType && (
                                <p>{role.employmentType}</p>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              ))
            ) : (
              <div className="campaignNotFound">
                {isAdvisorUser ? (
                  <img src="/assets/img/expround.svg" alt="" />
                ) : (
                  <img src="/assets/img/experienceCompany.svg" alt="" />
                )}
                <h6 className="m-0">No experience added yet</h6>
                <p className="m-0">
                  Experience details will appear here once available.
                </p>
              </div>
            )}
          </div>
        )}
      </div>
      {/* )} */}
    </div>
  );
};

export default ProfileSections;
